import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
export default function () {
    function onClick1(message, buttons, button, buttonIndex, e) {
        {
            button.onClick(e, button);
        }
    }
    function repeatButton2(message, buttons, button, buttonIndex) {
        return React.createElement('button', {
            'onClick': onClick1.bind(this, message, buttons, button, buttonIndex),
            'className': classNames('ui-button5', 'ui-button5--' + button.color),
            'key': 'buttonIndex' + buttonIndex
        }, '\r\n        ', button.text, '\r\n      ');
    }
    function scopeMessageButtons3() {
        var message = this.props.message;
        var buttons = this.props.buttons;
        return React.createElement('div', {
            'className': 'message-box-overlay',
            'key': '66'
        }, React.createElement('div', { 'className': 'ui-modal' }, React.createElement('div', {
            'className': 'ui-modal-text',
            'dangerouslySetInnerHTML': { __html: message }
        }), React.createElement.apply(this, [
            'div',
            { 'className': 'ui-modal-buttons' },
            _.map(buttons, repeatButton2.bind(this, message, buttons))
        ])));
    }
    return this.props.visible ? scopeMessageButtons3.apply(this, []) : null;
}